import { getResolvedErrorSrc176Evid101 } from '@wix/error-handler-core/@wix/bi-logger-os-data/v2';
import { withoutDefaults } from '../util/withoutDefaults';
export function reportGetResolvedErrorBi(errorHandler, params) {
  const {
    message,
    action,
    errorAccessor,
    errorResolution
  } = params;
  const {
    biLogger,
    commonErrorsMapState,
    translations
  } = errorHandler;
  const {
    error
  } = errorAccessor;
  const {
    consumerResolvedError
  } = errorResolution ?? {};
  biLogger.report(withoutDefaults(getResolvedErrorSrc176Evid101)({
    session_id: error == null ? void 0 : error._errorHandlerSessionId,
    translated_message: message,
    action_text: action == null ? void 0 : action.text,
    is_consumer_resolved_error: consumerResolvedError != null,
    common_errors_load_failed: String(commonErrorsMapState.commonErrors == null),
    isEn: translations.i18n.language === 'en'
  }));
}
//# sourceMappingURL=reportGetResolvedErrorBi.js.map